import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAutocomplete from "components/MDAutocomplete";

const BULAN_OPTIONS = [
  { value: "", label: "Semua Bulan" },
  { value: "1", label: "Januari" },
  { value: "2", label: "Februari" },
  { value: "3", label: "Maret" },
  { value: "4", label: "April" },
  { value: "5", label: "Mei" },
  { value: "6", label: "Juni" },
  { value: "7", label: "Juli" },
  { value: "8", label: "Agustus" },
  { value: "9", label: "September" },
  { value: "10", label: "Oktober" },
  { value: "11", label: "November" },
  { value: "12", label: "Desember" },
];

function PengajuanFilterBar({ filters, onChange, onReset, statusOptions }) {
  const currentYear = new Date().getFullYear();
  const yearOptions = [{ value: "", label: "Semua Tahun" }];
  for (let y = currentYear; y >= currentYear - 5; y -= 1) {
    yearOptions.push({ value: String(y), label: String(y) });
  }

  const handleChange = (field) => (newValue) => {
    onChange({ ...filters, [field]: newValue });
  };

  return (
    <MDBox mb={3} p={2} borderRadius="lg" bgColor="grey-100">
      <MDTypography variant="button" fontWeight="medium" mb={2} display="block">
        Filter Pengajuan
      </MDTypography>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm={6} md={3}>
          <MDAutocomplete
            label="Tahun"
            options={yearOptions}
            value={filters.tahun}
            onChange={handleChange("tahun")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MDAutocomplete
            label="Bulan"
            options={BULAN_OPTIONS}
            value={filters.bulan}
            onChange={handleChange("bulan")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MDAutocomplete
            label="Status"
            options={statusOptions}
            value={filters.status}
            onChange={handleChange("status")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MDButton variant="outlined" color="secondary" fullWidth onClick={onReset}>
            Reset Filter
          </MDButton>
        </Grid>
      </Grid>
    </MDBox>
  );
}

PengajuanFilterBar.propTypes = {
  filters: PropTypes.shape({
    tahun: PropTypes.string,
    bulan: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  statusOptions: PropTypes.array.isRequired,
};

export default PengajuanFilterBar;
